import {createWorkspaceUser as createWorkspaceUserGQL} from "../../graphql/mutations";
import {queryGqlApi} from "../../graphql/queryGqlApi";
import {IDataClientService} from "../../platform/services/data/DataClientService";
import {IAuthService} from "../../platform/services/auth/AuthService";
import {UserSessionState} from "@stores/UserSessionState";


export async function createWorkspaceUser(
    dataClientService: IDataClientService,
    authService: IAuthService,
    userState: UserSessionState,
    wsId: string, userId: string, userRole: string) {
    const queryResult = await queryGqlApi(
        createWorkspaceUserGQL,
        {
            input: {
                ownerId: userState.tenantId,
                workspaceId: wsId,
                userId: userId,
                role: userRole,
                createdBy: userState.currentUserId,
            }
        },
        dataClientService,
        authService,
        'main'
    );
    return queryResult;
}
